import { gql } from '@apollo/client';
import { image, video } from '../../utils/helperQuery.wp';

const deepDiveFields = `
  video {
    ${video}
  }
  videoThumbnail {
    ${image}
  }
  deepDive
`;

// One query per deep-dive post type — each targets its own GraphQL node and
// ACF field group. Keyed by the WP post type slug (`sourcePostType`).
export const deepDiveQueries = {
  staff: gql`
    query GetStaffDeepDive($id: ID!) {
      staffMember(id: $id, idType: DATABASE_ID) {
        staffOptions {
          ${deepDiveFields}
        }
      }
    }
  `,
  'board-members': gql`
    query GetBoardMemberDeepDive($id: ID!) {
      boardMember(id: $id, idType: DATABASE_ID) {
        boardMemberOptions {
          ${deepDiveFields}
        }
      }
    }
  `,
};
